import React from "react";

import { Image } from "../Image";

import "../../organisms/GenericHeader/styles.scss";
import "../../organisms/GenericFooter/styles.scss";
import "../../organisms/SectionThankYou/styles.scss";
import {
  RideButton,
  RideFiErrorLight,
} from "@rimac-seguros/ride-system-components";
import { getProductOptions } from "@/utils/product";

export const StaticFallBack = () => {
  const { homePath, title } = getProductOptions();

  const handleRedirect = () => {
    window.location.href = homePath;
  };

  const date = new Date();
  const currentYear = date.getFullYear();

  return (
    <div>
      <div className="App homeContainerBackground">
        <div className="rbr-rimac-grid o-hidden">
          <div className="rbr-section">
            <div className="rbr-section border-bt-N400">
              <div className="section-container">
                <div className="section-header">
                  <div className="section-header__left">
                    <Image
                      pngSrc="/ventadigital/devolucion/assets/rebrand/logo-rimac.svg"
                      alt="Logo Rimac"
                      className="img-logo"
                      fetchpriority="low"
                    />
                    <div className="separator "></div>
                    <p className="header-title ">{title}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="thank-you">
              <div className="thank-you__container v2">
                <RideFiErrorLight size="large" />
                <div className="thank-you__title mt-ride-gl-spacing-xlarge">
                  <h2>
                    ¡Algo falló!{" "}
                    <span>Hubo un error al cargar la información</span>
                  </h2>
                </div>
                <p className="thank-you__subtitle v2 text-center">
                  Surgió algo inesperado. Por favor, vuelve a intentarlo.
                </p>
                <RideButton
                  onClick={handleRedirect}
                  text="Volver a cotizar"
                  size="x-large"
                />
              </div>
            </div>
            <div>
              <div id="footerv2" className="container-footerv2 show-mobile ">
                <div className="container-footerv2__content">
                  <p>© {currentYear} RIMAC Seguros y Reaseguros.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
